import ProjectScopeDocActivityModule from './scope-doc-activity.module'

export default ProjectScopeDocActivityModule
